import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TagTextModule } from '../tag-text/tag-text.module';
import { MainTitleComponent } from './main-title.component';
import { TipMessageModule } from '../tip-message/tip-message.module';

@NgModule({
  declarations: [
    MainTitleComponent
  ],
  imports: [
    CommonModule,
    TagTextModule,
    TipMessageModule
  ],
  exports: [
    MainTitleComponent
  ]
})
export class MainTitleModule { }
